import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CircularProgress, IconButton, Alert } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import AddWorkoutCalender from "../Calender/AddWorkoutCalender";
import { memberDetail } from "src/DAL/Profile/Profile";
import {
  programmeDetailApi,
  get_workout_detail_api,
} from "src/DAL/programmeWorkout/programmeWorkout";
import moment from "moment";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

function WorkoutEditFullPage() {
  const classes = useStyles();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { id, CalId, workoutId } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [workoutData, setWorkoutData] = useState(null);
  const [programmeData, setProgrammeData] = useState(null);
  const [memberData, setMemberData] = useState(null);
  const [questionsToSend, setQuestionsToSend] = useState([]);
  const [editShow, setEditShow] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [modalChangeExe, setModalChangeExe] = useState(false);
  const [events, setEvents] = useState([]);

  const childRef = React.useRef();

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      enqueueSnackbar("Please log in to access this page", {
        variant: "warning",
      });
      navigate("/login");
      return;
    }
    const fetchData = async () => {
      try {
        setIsLoading(true);

        if (CalId) {
          const programResult = await programmeDetailApi(CalId);
          if (programResult.code === 200) {
            setProgrammeData(programResult.program);
          } else {
            enqueueSnackbar(programResult.message, { variant: "error" });
          }
        }

        if (workoutId) {
          // Fetch workout detail directly by ID
          const workoutResult = await get_workout_detail_api(workoutId);
          const memberResult = await memberDetail();

          if (workoutResult.code === 200 && workoutResult.workout) {
            const workout = workoutResult.workout;

            setWorkoutData(workout);
            setMemberData(memberResult?.member || memberResult);

            const newQuestions = workout?.questions || [];
            let que_list = [];
            if (newQuestions && newQuestions.length > 0) {
              que_list = newQuestions.map((item) => {
                return {
                  ...item,
                  loading: [],
                };
              });
              setQuestionsToSend(que_list);
              setEditShow(newQuestions.map(() => ({ display: false })));
            }
          } else {
            enqueueSnackbar(workoutResult.message, {
              variant: "error",
            });
            navigate("/dashboard");
          }
        }
      } catch (error) {
        console.error(error);
        enqueueSnackbar("Error loading workout", { variant: "error" });
        navigate("/dashboard");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [id, CalId, workoutId, enqueueSnackbar, navigate]);

  const handleSave = () => {
    if (childRef.current) {
      childRef.current.childButtonClickUpdate();
    }
  };

  const handleBack = () => {
    navigate("/dashboard");
  };

  const reloadList = async (message) => {
    if (message) {
      enqueueSnackbar(message, { variant: "success" });
    }

    try {
      const workoutResult = await get_workout_detail_api(workoutId);

      if (workoutResult.code === 200 && workoutResult.workout) {
        const updatedWorkout = workoutResult.workout;

        setWorkoutData(updatedWorkout);

        const newQuestions = updatedWorkout?.questions || [];
        let que_list = [];
        if (newQuestions && newQuestions.length > 0) {
          que_list = newQuestions.map((item) => {
            return {
              ...item,
              loading: [],
            };
          });
          setQuestionsToSend(que_list);
          setEditShow(newQuestions.map(() => ({ display: false })));
        }
      }
    } catch (error) {
      console.error("Error reloading workout:", error);
    }
  };

  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  if (!workoutData) {
    return (
      <div className="container-fluid">
        <div className="row mobile-margin display-flex">
          <div className="col-12"></div>
        </div>
        <div className="row section-space">
          <div className="col-12">
            <div className="d-flex align-items-center">
              <IconButton onClick={handleBack}>
                <ArrowBackIcon />
              </IconButton>
              <h1 className="programmes-heading ms-2">Workout not found</h1>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="row fixed_top">
        <div className="col-12 mb-2">
          <div className="d-flex align-items-center">
            <IconButton onClick={handleBack}>
              <ArrowBackIcon />
            </IconButton>
          </div>
        </div>

        {modalChangeExe && (
          <div className="col-12">
            <Alert
              sx={{
                textAlign: "left",
                width: "100%",
                backgroundColor: "#ff7f00",
                color: "#fff",
                "& .MuiAlert-icon": {
                  color: "#fff",
                },
              }}
              severity="warning"
            >
              You have unsaved changes. Remember to save them before closing.
            </Alert>
          </div>
        )}
      </div>

      <div
        className="row mt-3"
        style={{ paddingTop: modalChangeExe ? "100px" : "50px" }}
      >
        <div className="col-12">
          <AddWorkoutCalender
            setIsLoading={setIsSaving}
            ref={childRef}
            date={workoutData?.workout_date}
            programme={programmeData}
            member_id={id}
            setOpen={() => navigate("/dashboard")}
            editData={workoutData}
            day={moment(workoutData?.workout_date).format("dddd")}
            events={events}
            setEvents={setEvents}
            reloadList={reloadList}
            setModalChangeExe={setModalChangeExe}
            member_vdot={memberData?.vdot?.vdot_value || null}
            member_vdot_info={memberData?.vdot || null}
            questionsToSend={questionsToSend}
            setQuestionsToSend={setQuestionsToSend}
            editShow={editShow}
            setEditShow={setEditShow}
            setEditWorkputData={setWorkoutData}
          />
        </div>
      </div>

      <div className="row section-space">
        <div className="col-12 d-flex justify-content-end mb-3">
          {workoutData?.workout_has_logs ? (
            <button
              disabled={isSaving}
              onClick={isSaving ? null : handleSave}
              className="small-contained-button"
            >
              {isSaving ? "Saving..." : "Save"}
            </button>
          ) : (
            <>
              {workoutData?.practice_type !== "workbook" ||
              questionsToSend.length > 0 ? (
                <button
                  disabled={isSaving}
                  onClick={isSaving ? null : handleSave}
                  className="small-contained-button"
                >
                  {isSaving ? "Saving..." : "Save"}
                </button>
              ) : null}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default WorkoutEditFullPage;
